// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2w-Ek","row":"ProcedureTreatmentSummary_row__3NNMg"};